import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllSubscriptions, selectors as subscriptionsSelectors } from '@web-client/state/slices/subscriptions';
import { Box, Typography, LinearProgress, Grid, Card, CardContent, Avatar, Stack } from '@mui/material';
import { AppDispatch } from '@web-client/state/store';
import { useNavigate } from 'react-router-dom';
import Paths, { getCreatorSummaryPath } from '@web-client/paths';

const Subscriptions: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const subscriptions = useSelector(subscriptionsSelectors.subscriptionsList);
  const isLoading = useSelector(subscriptionsSelectors.isGettingSubscriptionsList);
  const error = useSelector(subscriptionsSelectors.subscriptionsListError);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllSubscriptions());
  }, [dispatch]);

  if (isLoading) {
    return (<LinearProgress variant='indeterminate' />);
  }

  if (error) {
    return (
      <Typography color="error" align="center">
        {error}
      </Typography>
    );
  }

  return (
    <Box sx={{ padding: 10 }}>
      <Typography variant="h1" className="gradient-text" gutterBottom>
        My Subscriptions
      </Typography>
      <Grid container spacing={3}>
        {subscriptions.length === 0 ? (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  No subscriptions yet.
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Subscribe to a creator to see them here.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          subscriptions.map((subscription: any) => (
            <Grid item xs={12} sm={6} md={4} key={subscription.creator?.uid || subscription.creator?.id}>
              <Card
                sx={{
                  '&:hover': {
                    boxShadow: 6,
                    cursor: 'pointer',
                  },
                }}
                onClick={() => {
                  navigate(getCreatorSummaryPath(subscription.creator?.uid || subscription.creator?.id));
                }}
              >
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar src={subscription.creator?.photoURL} alt={subscription.creator?.displayName} />
                    <Typography variant="h6">{subscription.creator?.displayName || subscription.creator?.email}</Typography>
                  </Stack>
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    {subscription.creator?.email}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default Subscriptions;